import { LeftOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import React from 'react';
import { PROMETHEE_BLUE } from '../../../../utils/const/colors';
import OfferDetail from './OfferDetail';

const MpOfferDetailDrawer = ({ offerId, open, onClose }) => {
  return (
    <Drawer
      closable={false}
      placement="right"
      onClose={onClose}
      open={open}
      width={620}
      destroyOnHidden
      title={
        <div>
          <Button
            type="link"
            icon={<LeftOutlined />}
            onClick={onClose}
            style={{ padding: 0 }}
          >
            Retour
          </Button>
          <div style={{ color: PROMETHEE_BLUE }}>Offre #{offerId}</div>
        </div>
      }
    >
      <OfferDetail offerId={offerId} />
    </Drawer>
  );
};

export default MpOfferDetailDrawer;
